import React from "react";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { ProgressSteps } from "@ui/ProgressSteps";
import { Page, CardBody, CardTitle } from "@ui/Page";
import { getStepsForBundle } from "@upload/selectors";
import { BundleUploader } from "@upload/components/BundleUploader";

type Props = RouteComponentProps<any>;

const breadcrumbItems = [
    {
        text: <FormattedMessage {...messages.pageBundlesTitle} />,
        to: "/bundles",
    },
    {
        text: <FormattedMessage {...messages.pageBundlesCreateTitle} />,
    },
];

const BundlesCreate = ({ history }: Props) => (
    <Page className="bundles-create-page" breadcrumbs={breadcrumbItems}>
        <CardBody>
            <ProgressSteps steps={getStepsForBundle(null)} />
            <CardTitle tag="h1">
                <FormattedMessage {...messages.pageBundlesCreateTitle} />
            </CardTitle>
            <BundleUploader onSuccess={(id: number) => history.push("/bundles/view/" + id)} />
        </CardBody>
    </Page>
);

const ConnectedBundlesCreate = compose<Props, {}>(
    setTitleOnPage(
        messages.pageBundlesTitle, messages.pageBundlesCreateTitle,
    ),
    withRouter,
)(BundlesCreate);

export {
    BundlesCreate as BundlesCreatePresenter,
    ConnectedBundlesCreate as BundlesCreate,
};
